import apiClient from 'utilities/apiClient';

export const FollowUp = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.followUps}/${url}`, payload, true);
};

export const FollowUpGet = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.followUps}/${url}`, payload, true);
};
